import { paramsToQueryString } from '../../helpers/url';
import { isEmpty } from 'Helpers/objects';
import { getType } from 'Reducers/helpers/typeModifier';
import memoize from 'lodash/memoize';

export function getFilledCollection(collectionType, reducerState, url, params = null, includeAllMetaData = false) {
    let urlWithParams = url;

    if (params !== null && !isEmpty(params)) {
        urlWithParams += `?${paramsToQueryString(params)}`;
    }

    const collection = reducerState.collections[getType(collectionType, urlWithParams)];
    const collectionMetadata = reducerState.collectionMetadata[getType(collectionType, urlWithParams)];

    if (!Array.isArray(collection)) {
        return [];
    }

    const result = collection.map(id => Object.assign({}, reducerState.elements[id]));

    if (collectionMetadata) {
        result.total = collectionMetadata.total;
        result.cursor = collectionMetadata.cursor;
        result.nextPageUrl = collectionMetadata.nextPageUrl;
    }
    if (includeAllMetaData) {
        Object.keys(collectionMetadata).forEach(key => {
            result[key] = collectionMetadata[key];
        });
    }

    return result;
}

export function getUrlNextPage(reducerState, url, type, params = null) {
    let urlWithParams = url;

    if (params !== null && !isEmpty(params)) {
        urlWithParams += `?${paramsToQueryString(params)}`;
    }
    const reducerType = getType(type, urlWithParams);

    const currentCollection = reducerState.collections[reducerType];
    const currentCollectionMetadata = reducerState.collectionMetadata[reducerType] || {};
    const hasNextPage = currentCollectionMetadata.nextPageUrl || currentCollectionMetadata.cursor;

    if (!currentCollection || !currentCollectionMetadata || !hasNextPage) {
        return urlWithParams;
    }

    let finalParams;

    if (currentCollectionMetadata.cursor) {
        finalParams = { ...params, cursor: currentCollectionMetadata.cursor };
    }

    if (currentCollectionMetadata.nextPageUrl) {
        return `${url}?${currentCollectionMetadata.nextPageUrl}`;
    }

    if (url.indexOf('?') > -1) {
        return `${url}&${paramsToQueryString(finalParams)}`;
    }
    return `${url}?${paramsToQueryString(finalParams)}`;
}

const memoizedCategoryTree = memoize(
    (categoryObj, category) => {
        const categoryArr = [];

        categoryArr.push(categoryObj[category]);

        for (const cat in categoryObj) {
            if (Object.prototype.hasOwnProperty.call(categoryObj, cat)) {
                const subCats = categoryObj[cat]?.sub_categories || [];

                if (subCats.includes(category)) {
                    categoryArr.push(categoryObj[cat]);
                }
            }
        }

        const categoryTree = {};

        categoryArr.reverse().forEach((cat, index) => {
            categoryTree[`L${index + 1}`] = cat;
        });

        return categoryTree;
    },
    (categoryObj, category) => `${categoryObj }_${ category}`
);

export function getCategoryTree(categoryObj, category) {
    return memoizedCategoryTree(categoryObj, category);
}

export function callHasBeenMadeForCollection(reducerState, url, params = null) {
    const property = isEmpty(params) ? url : `${ url }?${ paramsToQueryString(params) }`;

    return Object.prototype.hasOwnProperty.call(reducerState.collections, property) || Object.prototype.hasOwnProperty.call(reducerState.collections, `items#${property}`);
}

export function getCollectionMetadataKey(key, type, reducerState, url, params = null) {
    let result;
    let urlWithParams = url;

    if (params !== null) {
        urlWithParams += `?${ paramsToQueryString(params) }`;
    }

    const collectionMetadata = reducerState.collectionMetadata[getType(type, urlWithParams)];

    if (collectionMetadata) {
        result = collectionMetadata[key];
    }

    return result;
}

export function getMappedCategories(type, reducerState, url, params) {
    const categories = getFilledCollection(type, reducerState, url, params);

    return categories.map(category => mapSubcategories(reducerState, category));
}

export function mapSubcategories(reducerState, category) {
    const newCategory = Object.assign({}, category);

    newCategory.sub_categories = (category.sub_categories || []).map(id => {
        const subcategory = reducerState.elements[id];

        if (subcategory && subcategory.sub_categories) {
            return mapSubcategories(reducerState, subcategory);
        }

        return subcategory;
    });
    return newCategory;
}
